module.exports = {"340706100":"五松镇","340706101":"顺安镇","340706102":"钟鸣镇","340706103":"天门镇","340706200":"老洲乡","340706201":"东联乡","340706202":"西联乡","340706203":"胥坝乡","340706400":"循环经济园","340706401":"金桥经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340706.json
// module id = 999
// module chunks = 0